import { useIndexedDB } from "react-indexed-db-hook";
import { useEffect, useState } from "react";
import useParkingInfoStore from "stores/useParkingInfoStore";
import { IParkingSession } from "types/vehiclePicker.type";

export default function useParkingSession() {
    const { setSessions } = useParkingInfoStore();
    const dbValues = useIndexedDB("parkingSession");
    const { getAll, add, deleteRecord, getByIndex: _getByIndex, clear: clearAll, update } = dbValues;

    const [parkingSession, setParkingSession] = useState<IParkingSession[]>([]);
    useEffect(() => {
        getAll<IParkingSession>()
            .then((valuesFromDB) => {
                setSessions(valuesFromDB || []);
                setParkingSession(valuesFromDB);
            })
            .catch(() => setParkingSession([]));
    }, [dbValues]);

    const getByIndex = (indexName: keyof IParkingSession, key: any) => {
        if (indexName === "id") {
            key = parseInt(key);
        }
        return parkingSession.find((parkingSession) => parkingSession[indexName] === key);
    };

    const deleteByIndex = (indexName: keyof IParkingSession, key: any) => {
        if (indexName === "id") {
            return deleteRecord(parseInt(key)).then(() => {
                return getAll<IParkingSession>().then((valuesFromDB) => {
                    setSessions(valuesFromDB || []);
                    setParkingSession(valuesFromDB || []);
                });
            });
        } else {
            return _getByIndex(indexName, key).then((parkingSession) => {
                if (parkingSession && parkingSession.id) {
                    return deleteRecord(parkingSession.id).then(() => {
                        return getAll().then((valuesFromDB) => {
                            setSessions(valuesFromDB || []);
                            setParkingSession(valuesFromDB || []);
                        });
                    });
                }

                return Promise.resolve();
            });
        }
    };

    const updateSession = (session: IParkingSession) => {
        return update(session).then(() => {
            return getAll<IParkingSession>().then((valuesFromDB) => {
                setSessions(valuesFromDB || []);
                setParkingSession(valuesFromDB || []);
            });
        });
    };

    return {
        parkingSession,
        add,
        deleteRecord,
        getByIndex,
        getByIndexAsync: _getByIndex,
        deleteByIndex,
        clearAll,
        getAll,
        updateSession,
    };
}
